import React, { useEffect, useRef } from 'react'

// Trustpilot "Review Collector" TrustBox.
//
// The bootstrap script (loaded in public/index.html) scans the DOM for
// .trustpilot-widget nodes once, when it finishes loading. This is a SPA, so
// the hero almost always mounts *after* that scan and the widget would stay
// empty. Calling loadFromElement on mount hydrates this specific node.
//
// Note: the Review Collector template renders as a fixed white button and
// ignores data-theme (verified: light and dark render identically), so its
// placement is handled by .trustpilot-strip in App.css rather than by Trustpilot.
//
// Widget IDs come from the client's Trustpilot account — do not edit by hand.
const TRUSTBOX = {
    templateId: '56278e9abfbbba0bdcd568bc', // "Review Collector"
    businessunitId: '6a20707bdbcb27a684e65a89',
    token: '0c27410b-59b7-4860-85a9-32bb7c6db56f',
    profileUrl: 'https://www.trustpilot.com/review/adroitspot.com',
}

const TrustpilotWidget = () => {
    const ref = useRef(null)

    useEffect(() => {
        // Script may still be in flight (it's async) — if so the initial scan
        // will catch this node anyway, so a no-op here is safe.
        if (window.Trustpilot && ref.current) {
            window.Trustpilot.loadFromElement(ref.current, true)
        }
    }, [])

    return (
        <div
            ref={ref}
            className="trustpilot-widget"
            data-locale="en-US"
            data-template-id={TRUSTBOX.templateId}
            data-businessunit-id={TRUSTBOX.businessunitId}
            data-style-height="52px"
            data-style-width="100%"
            data-token={TRUSTBOX.token}
        >
            {/* Fallback link shown until the widget hydrates (and for crawlers). */}
            <a href={TRUSTBOX.profileUrl} target="_blank" rel="noopener noreferrer">Trustpilot</a>
        </div>
    )
}

export default TrustpilotWidget
